<template>
  <div id="diy-search">
    <!-- 自定义搜索项 -->
    <div class="item" v-for="(item, index) in data" :key="index">
      <!-- <div class="title" v-if="item.type != 'check'">{{ item.name }}</div> -->
      <div class="value" v-if="item.type == 'input'">
        <el-input v-model="item.value" :placeholder="'请输入' + item.name" suffix-icon="el-icon-search" clearable
          @keyup.enter.native="initTableData"></el-input>
      </div>
      <div class="value" v-if="item.type == 'input-search'">
        <el-input v-model="item.value" :placeholder="'请输入' + item.name" clearable @keyup.enter.native="initTableData">
          <el-button @click="initTableData" slot="append" icon="el-icon-search"></el-button></el-input>
      </div>

      <div class="value" v-if="item.type == 'select'">
        <el-select v-model="item.value" :placeholder="'请选择' + item.name" filterable clearable @change="initTableData">
          <el-option v-for="(it, ii) in item.options" :key="ii" :label="it.label" :value="it.value">
          </el-option>
        </el-select>
      </div>
      <div class="value" v-if="item.type == 'select-noclean'">
        <el-select v-model="item.value" :placeholder="'请选择' + item.name" filterable @change="initTableData">
          <el-option v-for="(it, ii) in item.options" :key="ii" :label="it.label" :value="it.value">
          </el-option>
        </el-select>
      </div>
      <div class="value" v-if="item.type == 'select2'">
        <el-select v-model="item.value" placeholder="请选择" filterable @change="initTableData">
          <el-option v-for="(it, ii) in item.options" :key="ii" :label="it.label" :value="it.value"
            :disabled="it.disabled">
          </el-option>
        </el-select>
      </div>
      <div class="value" v-if="item.type == 'check'">
        <el-checkbox v-model="item.value" @change="initTableData">{{
      item.name
    }}</el-checkbox>
      </div>
      <div class="value" v-if="item.type == 'check'">
        <el-checkbox v-model="item.value" @change="initTableData">{{
      item.name
    }}</el-checkbox>
      </div>
      <!-- 日期：年 -->
      <div class="value" v-if="item.type == 'year'">
        <el-date-picker v-model="item.value" type="year" format="yyyy" value-format="yyyy" placeholder="选择年份"
          @change="initTableData">{{
      item.name
    }}>
        </el-date-picker>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    searchData: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  watch: {
    searchData(newValue, oldValue) {
      console.log("监听", newValue);
      this.data = this.searchData;
    },
  },
  data() {
    return {
      data: this.searchData,
    };
  },
  methods: {
    initTableData() {
      this.$emit("initTableData");
    },
  },
  mounted() {

  },
};
</script>

<style lang="less" scoped>
#diy-search {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;

  >.item {
    width: 220px;
    height: 35px;
    margin: 5px;
    display: flex;
    align-items: center;

    >.title {
      width: 70px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 3px;
      box-sizing: border-box;
      font-size: 14px;
    }

    >.value {
      width: 0;
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      justify-items: center;
    }

    >.outer {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 10px;
    }
  }
}
</style>
